<template>
  <div class="botao-rolagem">
    <button class="btn-atalho" @click="$router.push('/tabela-de-preco')">
      <span
        >Tabela<strong><br />de<br />Preço</strong>
      </span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'BotaoTabelaDePrecos',
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

.botao-rolagem {
  position: relative;

  > button {
    display: flex !important;
    justify-content: center;
    align-items: center;
  }

  & .btn-atalho {
    display: flex;
    flex-direction: center;
    justify-content: center;
    @extend %nao-selecionavel;
    font-family: 'VivoType';
    font-weight: bold;
    background-color: $cor_roxo;
    color: white;
    font-size: 8px;
    line-height: 8px;
    width: 40px;
    height: 40px;
    border-radius: 22px;
    border: 0px;
    text-transform: uppercase;
    text-align: center;
    outline: none;
    transition: all 0.2s linear;
    cursor: pointer;
    padding: 0px;
    padding-bottom: 0px !important;
    box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.25);
    margin-top: 5px;

    & strong {
      color: $cor_amarelo;
    }

    &:hover {
      transform: scale(1.2);
    }
    &:focus {
      animation: grow 0.25s linear;
    }
  }
}
@keyframes grow {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

@media all and (min-width: 300px) and (max-width: 1000px) {
  .botao-rolagem {
    & .btn-atalho {
      font-size: 7px;
      line-height: 7px;
      &:hover {
        transform: none;
      }
    }
  }
}
/**
  Transition
 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
